import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Member_complete_project() {
    const navigate = useNavigate();
    const [listProjectArray, setListProjectArray] = useState([]);
    const [memFirstName, setMemFirstName] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    var memfname = localStorage.getItem('memberFirstname');

    useEffect(() => {
        const userid = localStorage.getItem('member_id');
        var obj = {
            userid: userid
        }
        $.ajax({
            type: 'POST',
            url: 'getMembersProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('You have no completed project.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });
        setOthers()
    }, []);
    function setOthers() {
        setMemFirstName(memfname)
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    function goForMemberProjectDetails(id, pro_name, deadline) {
        localStorage.setItem('selected_project_id', id);
        localStorage.setItem('selected_project_name', pro_name);
        localStorage.setItem('initialpage', 'members');
        localStorage.setItem('deadline', deadline);
        navigate('/complete_project_details');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Your Projects</h2>
                    <Link className='pull_right add_new_pro' to="/member_projectlist">Back To Active Projects</Link>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <p>{memFirstName} here you can see all completed projects</p>
                    <div className='vl_listing_area'>
                        <div className='vl_listing_row'>
                            <div className='vl_listing_cell width20'>
                                <h4 className='prj_name'>Project Name</h4>
                            </div>
                            <div className='vl_listing_cell width20'>
                                <p>Your Role</p>
                            </div>


                            <div className='vl_listing_cell width10'>
                                <p>Accept</p>
                            </div>
                            <div className='vl_listing_cell width10'>
                                <p>Deadline</p>
                            </div>
                            <div className='vl_listing_cell width20'>
                                <p>Action</p>
                            </div>
                        </div>
                        {listProjectArray.map((item, index) => {
                            const activestatus = item.project_status === 'complete';
                            const acceptpro = item.accept;
                            if (!activestatus) return null; // skip inactive items

                            return (
                                <div className='vl_listing_row' key={index}>
                                    <div className='vl_listing_cell width20'>
                                        <h4 className='prj_name'>{item.pro_name}</h4>

                                    </div>

                                    <div className='vl_listing_cell width40 hig120 prdetails'>
                                        <p>{item.member_role}</p>

                                    </div>

                                    <div className='vl_listing_cell width10'>
                                        <p>{item.accept}</p>
                                    </div>

                                    <div className='vl_listing_cell width10'>
                                        <p>{item.deadline}</p>
                                    </div>

                                    <div className='vl_listing_cell width10'>
                                        <p>{item.pr_last_date}</p>
                                    </div>

                                    <div className='vl_listing_cell width20'>
                                        {acceptpro === 'yes' ? (
                                            <button onClick={() => goForMemberProjectDetails(item.proid, item.pro_name, item.deadline)}>
                                                View
                                            </button>
                                        ) : (
                                            <p >
                                                You was Not accepted
                                            </p>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
